import { Grid } from '@mui/material';
import { memo, useEffect } from 'react';

import useTopPanel from 'hooks/useTopPanel';
import AccounterFilter from 'components/ui/filters/items/AccounterFilter';
import ProductStatistics from './items/ProductStatistics';
import ExpStatFilter from './items/ExpStatFilter';

const IncomeOutcome = () => {
  const { setComponent } = useTopPanel();

  useEffect(() => {
    setComponent(
      <div className='component-title flex gap-8 items-center'>
        Kirim chiqim statistikasi
        <div className='min-w-[250px]'>
          <AccounterFilter allowClear query='account_id' />
        </div>
      </div>
    );
  }, []);

  return (
    <div className='component-wrapper boss-residential-complex-wrapper'>
      <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
        <Grid item={true} lg={12} md={12} sm={12} xs={12}>
          <ExpStatFilter />
        </Grid>
        <Grid item={true} lg={12} md={12} sm={12} xs={12}>
          <ProductStatistics />
        </Grid>
      </Grid>
    </div>
  );
};
export default memo(IncomeOutcome);
